export default __webpack_public_path__ + "static/media/q17.a61b78c1.png";